import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from "@design-system/components";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { FEATURE_FLAGS } from "@spiriidk/connect-configs";
import { useFlag } from "@spiriidk/feature-flags";
import React, { useState } from "react";

import { isConnectRoute } from "~/utils/routes";

function useFlagChange(currentValue: boolean) {
  const [acknowledgedValue, setAcknowledgedValue] = useState(currentValue);

  const hasChanged = acknowledgedValue !== currentValue;
  const dismiss = () => setAcknowledgedValue(currentValue);

  return { hasChanged, dismiss };
}

function SpiriiUIFlagWatcher() {
  const { _ } = useLingui();
  const isSpiriiUIEnabled = useFlag(FEATURE_FLAGS.SPIRII_UI);
  const { hasChanged, dismiss } = useFlagChange(isSpiriiUIEnabled);

  const currentPath = window.location.pathname;
  const shouldRedirect = isConnectRoute(currentPath);

  const handleAction = shouldRedirect
    ? () => (window.location.href = "/")
    : () => window.location.reload();

  return (
    <AlertDialog open={hasChanged}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {shouldRedirect
              ? _(msg`Page No Longer Available`)
              : _(msg`Navigation Updated`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {shouldRedirect
              ? _(
                  msg`Connect has been disabled and this page is no longer accessible. Please return to the home page.`
                )
              : _(
                  msg`The navigation has been updated. Please refresh to see the changes.`
                )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="default" onClick={dismiss}>
            {_(msg`Cancel`)}
          </Button>
          <Button variant="emphasised" onClick={handleAction}>
            {shouldRedirect ? _(msg`Go to Home`) : _(msg`Refresh`)}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export { SpiriiUIFlagWatcher };
